export function negativeBoolean<T>(statement: T) {
  return !statement
}
